module.exports = __webpack_public_path__ + "static/DragonEX-6b9ad76e98912d924aa848c3380cc79b.png";